import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { TrButton } from '@skytech/ui/Table/TrButton'

import { useTranslation } from '@/app/translations/translations-hooks'
import Highlight from '@/components/Highlight'
import { useFormattedNumber } from '@/hooks/use-formatted-number'
import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'

import type { SalaryDeductionProfile } from '../resources'

export const TelePoliciesListItem: FC<
  SalaryDeductionProfile & {
    searchFilter: string
    onEdit: () => void
  }
> = ({
  name,
  freeAllowanceAmount,
  telePolicyTemplate,
  customerHeadId,
  searchFilter,
  onEdit,
  customer,
  customerHead,
  subscribers,
}) => {
  const translate = useTranslation()
  const { formatNumber: formatNumberWithCurrency } = useFormattedNumberWithCurrency()
  const { formatNumber } = useFormattedNumber()

  const currency = customerHead?.corporateCustomer?.country?.currency || customer?.country?.currency

  return (
    <TrButton onClick={onEdit}>
      <Td>
        <Highlight pattern={searchFilter} text={name} />
      </Td>

      <Td>
        <Highlight pattern={searchFilter} text={telePolicyTemplate?.name} />
      </Td>
      <Td>
        <Highlight
          pattern={searchFilter}
          text={customerHeadId ? translate('Local') : translate('Global')}
        />
      </Td>
      <Td className="text-right">
        <Highlight
          pattern={searchFilter}
          text={formatNumberWithCurrency({ amount: Number(freeAllowanceAmount), currency })}
        />
      </Td>

      <Td className="text-right">
        <Highlight pattern={searchFilter} text={formatNumber({ amount: Number(subscribers) })} />
      </Td>
    </TrButton>
  )
}
